import React from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import CreatePartyPage from './pages/CreatePartyPage';
import JoinPartyPage from './pages/JoinPartyPage';
import LobbyPage from './pages/LobbyPage';
import GamePage from './pages/GamePage';
import AccordingToGamePage from './pages/AccordingToGamePage';
import GameAnalysis from './pages/GameAnalysis';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import ProfilePage from './pages/ProfilePage';
import SupportPage from './pages/SupportPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';

const API_URL = 'https://who-is-backend.vercel.app/api';
// const API_URL = 'http://localhost:3001/api';
// const API_URL = 'http://192.168.0.32:3001/api';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
        <Route path="/" element={<HomePage />} />
        {/* <Route path="/create" element={<CreatePartyPage API_URL={API_URL} />} /> */}
        <Route path="/join" element={<JoinPartyPage API_URL={API_URL} />} />
        <Route path="/lobby/:code" element={<LobbyPage API_URL={API_URL} />} />
        <Route path="/game/:code" element={<GamePage API_URL={API_URL} />} />
        <Route path="/accordingto/:code" element={<AccordingToGamePage API_URL={API_URL} />} />
        <Route path="/analysis/:code" element={<GameAnalysis />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;